import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import QualityFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/quality_filters_group';
import RelevanceFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/relevance_filters_groups';
import ExclusionFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/exclusion_filters_group';
import AdvancedFiltersGroup from 'talent_matching/talent_rediscovery/components/filters/advanced_filters_group';
import RediscoveryAppliedFilters from 'talent_matching/talent_rediscovery/components/filters/rediscovery_applied_filters'; // eslint-disable-line max-len
import type { RediscoveryPageDefaults } from 'talent_matching/talent_rediscovery/types';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
  onReset: () => void;
  formDefaults: RediscoveryPageDefaults;
  children: React.ReactNode;
};

const RediscoveryFilterRow = ({
  onClearAll,
  onReset,
  formDefaults,
  children,
}: Props) => {
  return (
    <Stack spacing={0} sx={{ marginBottom: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <QualityFiltersGroup />
          <RelevanceFiltersGroup />
          <ExclusionFiltersGroup />
          <AdvancedFiltersGroup />
          <TertiaryButton size="md" onClick={onReset}>
            {t('buttons.reset_to_default')}
          </TertiaryButton>
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('buttons.clear_all')}
          </TertiaryButton>
        </NoWrap>
        {children}
      </Stack>
      <RediscoveryAppliedFilters formDefaults={formDefaults} />
    </Stack>
  );
};

export default RediscoveryFilterRow;
